import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataGridComponent } from './components/data-grid/data-grid.component';
import { FieldDataGridHeaderColumnComponent } from './components/field-data-grid-header-column/field-data-grid-header-column.component';
import { CommandDataGridColumnComponent } from './components/command-data-grid-column/command-data-grid-column.component';
import { DataGridSelectableColumnComponent } from './components/data-grid-selectable-column/data-grid-selectable-column.component';
import { DataGridDetailRowComponent } from './components/data-grid-detail-row/data-grid-detail-row.component';
import { DataGridEditableRowComponent } from './components/data-grid-editable-row/data-grid-editable-row.component';
import { DataGridFieldColumnComponent } from './components/data-grid-field-column/data-grid-field-column.component';
import { DataGridFieldEditorColumnComponent } from './components/data-grid-field-editor-column/data-grid-field-editor-column.component';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { FormsModule } from '@angular/forms';
import { CommandModalModule } from '../command-modal/command-modal.module';
import { AlertFacadeServiceModule } from '../alert-facade-service/alert-facade-service.module';
import { DynamicComponentModule } from '../dynamic-component/dynamic-component.module';

@NgModule({
  declarations: [DataGridComponent, FieldDataGridHeaderColumnComponent, CommandDataGridColumnComponent, DataGridSelectableColumnComponent, DataGridDetailRowComponent, DataGridEditableRowComponent, DataGridFieldColumnComponent, DataGridFieldEditorColumnComponent],
  entryComponents: [],
  imports: [
    DynamicComponentModule,
    CommonModule,
    FomanticUIModule,
    FormsModule,
    CommandModalModule,
    AlertFacadeServiceModule
  ],
  exports: [DataGridComponent]
})
export class DataGridModule { }
